import vsbl from 'vsbl'

function lazim (attr = 'data-src') {
  return {
    bind () {
      const nodes = document.querySelectorAll('[' + attr + ']')

      for (let i = 0; i < nodes.length; i++) {
        const node = nodes[i]
        const img = node.getElementsByTagName('img')[0]
        const src = node.getAttribute(attr)

        if (img) {
          img.onload = () => {
            node.classList.add('is-loaded')
          }
        }

        node.removeAttribute(attr)

        vsbl(node)(() => {
          node.classList.add('is-visible')
          if (img) {
            img.src = src
          }
        })
      }
    }
  }
}

export default lazim()



// WEBPACK FOOTER //
// ./src/scripts/lib/lazy-image.js